// Firebase configuration and initialization (npm imports)
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import {
  getAuth,
  signInAnonymously,
  onAuthStateChanged,
  setPersistence,
  browserLocalPersistence,
  signInWithCustomToken,
  signOut,
} from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { FIREBASE_STORAGE_BUCKET } from '../logic/config.js';

const firebaseConfig = {
  apiKey: 'AIzaSyDK1COdsbzaRyXQpwMLiqFmsd_jEOJHxpg',
  authDomain: 'binder-browser.firebaseapp.com',
  projectId: 'binder-browser',
  storageBucket: FIREBASE_STORAGE_BUCKET,
  messagingSenderId: '290116241152',
  appId: '1:290116241152:web:1afbf0410809c2822495e5',
  measurementId: 'G-20HVY2QYXD',
};

// Exported so services/telemetry.js can attach the Analytics and Performance
// SDKs to the same app. Those SDKs are NOT initialized here: they are loaded
// lazily, and only on production hosts. See logic/telemetry-gate.js.
export const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);

// Re-export auth utilities for convenience
export {
  signInAnonymously,
  onAuthStateChanged,
  setPersistence,
  browserLocalPersistence,
  signInWithCustomToken,
  signOut,
  httpsCallable,
};
